module.exports = __webpack_public_path__ + "img/xnes-intro.cb5fafea.svg";